import {Injectable} from '@angular/core';
import {BaseReactiveStore} from "../../shared/base-reactive-store";
import {LanguageDto, LocalizationDto} from "../app-config/models/application-configuration-dto";
import {AppConfigService} from "../app-config/app-config.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LocalizationService extends BaseReactiveStore<LocalizationDto> {

  languages$: Observable<Array<LanguageDto>>
    = this.select(state => state.languages)

  constructor(private appConf: AppConfigService) {
    super(new LocalizationDto())

    this.appConf.localization$.subscribe(value => {
      this.setState(value);
    });
  }

  public Localize(s: string): string {
    const parts = s.split(':');
    if (parts.length != 2) {
      return s
    } else {
      const st = this.state

      if (!st.values[parts[0]]) {
        return s;
      }

      const module = st.values[parts[0]]!
      return module[parts[1]] ?? s

    }
  }


}
